(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hookout-product-discovery"] && !Shopify.designMode) return;
  try {
    
function setupHookOutDiscovery(root) {
  if (root.dataset.hxReady) return;
  root.dataset.hxReady = 'true';
  const filters = root.querySelector('.hx-filters');
  if (!filters) return;
  filters.hidden = false;
  filters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hx-filter]');
    if (!button) return;
    const filter = button.dataset.hxFilter;
    filters.querySelectorAll('button').forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
    const update = () => root.querySelectorAll('[data-hx-category]').forEach((card) => { card.hidden = filter !== 'all' && card.dataset.hxCategory !== filter; });
    if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
    else update();
  });
}
document.querySelectorAll('.hx-home').forEach(setupHookOutDiscovery);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.hx-home').forEach(setupHookOutDiscovery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hookout-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hookout-video-carousel')) {
    customElements.define('hookout-video-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const track = this.querySelector('.ho-action__track');
        if (!track) return;
        const arrows = this.querySelector('.ho-action__arrows');
        const previous = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        const videos = Array.from(this.querySelectorAll('video'));
        const update = () => {
          const overflow = track.scrollWidth - track.clientWidth;
          arrows.hidden = overflow < 4;
          previous.disabled = track.scrollLeft < 4;
          next.disabled = track.scrollLeft >= overflow - 4;
        };
        const move = direction => {
          const card = track.querySelector('.ho-action__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        videos.forEach(video => {
          const play = video.parentElement.querySelector('.ho-action__play');
          play.hidden = false;
          play.addEventListener('click', () => video.play().catch(() => { play.hidden = false; }), options);
          video.addEventListener('play', () => {
            play.hidden = true;
            videos.forEach(other => { if (other !== video) other.pause(); });
          }, options);
          video.addEventListener('pause', () => { play.hidden = false; }, options);
          video.addEventListener('ended', () => { play.hidden = false; }, options);
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
          }, { threshold: 0.2 });
          videos.forEach(video => this.observer.observe(video));
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) videos.forEach(video => video.pause());
        }, options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
